module.exports = __webpack_public_path__ + "img/account-avatar.275655b5.svg";